import {Platform} from 'react-native';
import {connect} from 'react-redux';
import {get} from 'lodash/fp';
import {createStructuredSelector} from 'reselect';

import {
  getDispositionOptions,
  getProfile,
  getRefreshedProfile,
  resetAllCandidatesInfo,
  saveDispositionData,
} from '/redux/action/candidate.action';
import {AllCandidatesReduxKeys, resetReport} from '/redux/action/report.action';
import {
  candidateById,
  candidateNameById,
  dispositionDescription,
  dispositionOptions,
  dispositionTypeId,
  hasdispositionOptions,
  hasProfileById,
  isPendingAcceptance,
  statusById,
} from '/redux/selector/candidate.selector';
import {paidAsRankDescLastMonth} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {variablesFeatureFlag} from '/redux/selector/remoteConfig.selector';
import {allReportData} from '/redux/selector/report.selector';
import {fromProps, withProps} from '/util/selector.util';

import {CandidateProfile} from './CandidateProfile';

const withCandidateId = withProps({
  candidateId: fromProps(get('recordId')),
});

export default connect(
  createStructuredSelector({
    featureFlag: variablesFeatureFlag,
    hasProfile: withCandidateId(hasProfileById),
    candidateData: withCandidateId(candidateById),
    isPendingAcceptance: withCandidateId(isPendingAcceptance),
    status: withCandidateId(statusById),
    candidateName: withCandidateId(candidateNameById),
    dispositionDescription: withCandidateId(dispositionDescription),
    dispositionOptionArray: dispositionOptions,
    hasdispositionOptions,
    dispositionTypeId: withCandidateId(dispositionTypeId),
    allReportData,
    userId,
    lastPaidRank: withProps({coachId: userId})(paidAsRankDescLastMonth),
  }),

  dispatch => ({
    getProfile: ({candidateId}: any) =>
      dispatch<any>(getProfile({candidateId})),
    getRefreshedProfile: ({candidateId}: any) =>
      dispatch<any>(getRefreshedProfile({candidateId})),
    resetReport: ({reportKey}: any) =>
      dispatch<any>(resetReport({reportKey, data: null})),
    resetAllCandidatesInfo: () =>
      dispatch<any>(resetAllCandidatesInfo({inputPayload: null})),
    getDispositionOptions: () =>
      dispatch<any>(getDispositionOptions({inputPayload: null})),
    saveDispositionData: ({candidateId, body, allReportData}: any) =>
      // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
      dispatch(saveDispositionData({candidateId, body, allReportData})),
  }),
  (stateProps, dispatchProps, ownProps) => {
    const {hasProfile, candidateData, isPendingAcceptance} = stateProps;
    const {recordId: candidateId} = ownProps;
    return {
      ...stateProps,
      ...dispatchProps,
      ...ownProps,
      isPendingAcceptance: Platform.OS === 'web' ? false : isPendingAcceptance,
      hasData: hasProfile,
      hasCandidateData: candidateData && Object.keys(candidateData).length > 0,
      fetchData: () => {
        return dispatchProps.getProfile({candidateId});
      },
      resetCachedMetrics: () => {
        return dispatchProps.getRefreshedProfile({candidateId});
      },
      resetCandidatesData: () => {
        dispatchProps.resetAllCandidatesInfo();
        AllCandidatesReduxKeys.forEach((element: any) => {
          dispatchProps.resetReport({
            reportKey: element,
          });
        });
      },
      getDispositionOptions: () => {
        return dispatchProps.getDispositionOptions();
      },

      saveDispositionData: (candidateId: any, body: any) => {
        const {allReportData} = stateProps;
        return dispatchProps.saveDispositionData({
          candidateId,
          body,
          allReportData,
        });
      },
    };
  },
)(CandidateProfile);
